import styled, { css } from 'styled-components';

import { BaseStyle, ReactTableStyles } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const SIZING = {
    playerName: {
        large: 160,
        small: 120,
    },
    sweaterNumber: {
        large: 38,
        small: 28,
    },
};

const createSizing = (sizing) => `
    flex: ${sizing}px;
    max-width: ${sizing}px;
    min-width: ${sizing}px;
    width: ${sizing}px;    
`;

export const TeamRosterContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.teamRoster};
    position: relative;
`;

export const RosterHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.gaps.medium}
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        margin: 0;
    }
`;

export const HeaderContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
`;

export const SubHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
    color: ${({ theme }) => theme.Text.secondary};
`;

export const RosterLink = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.primary};
    padding: 5px 0;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const StickySortStyle = css`
    &.sorted-0 {
        background: ${({ theme }) => theme.Table.highlightPrimary};
    }

    &.sorted-1 {
        background: ${({ theme }) => theme.Table.highlightSecondary};
    }

    &.sorted-2 {
        background: ${({ theme }) => theme.Table.highlightTertiary};
    }
`;

export const StickyTable = css`
    .sticky {
        position: sticky;
        z-index: 1;
    }

    .rt-tr:nth-child(odd) .rt-td.sticky {
        ${StickySortStyle};
        background: ${({ theme }) => theme.Table.zebraStripe};
    }

    .rt-tr:nth-child(even) .rt-td.sticky,
    .rt-th.sticky {
        ${StickySortStyle};
        background: ${({ theme }) => theme.Surface.primary};
    }
`;

export const TeamRosterTableContainer = styled.div`
    margin-bottom: 8px;
    container-type: inline-size;

    ${ReactTableStyles.CommonTableStyling};

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows};
    }

    .rt-table {
        ${StickyTable};

        .player-name {
            border-right: 1px solid ${({ theme }) => theme.Surface.border};
            left: ${SIZING.sweaterNumber.small}px;

            ${BaseStyle.Mixins.screenSizes.medium} {
                ${createSizing(SIZING.playerName.large)};
                left: ${SIZING.sweaterNumber.large}px;
            }
        }

        .player-name .sortable-table-header,
        .player-name.rt-td {
            padding-left: 4px;

            ${BaseStyle.Mixins.screenSizes.medium} {
                padding-left: 16px;
            }
        }

        .sweater-number {
            left: 0;

            ${BaseStyle.Mixins.screenSizes.medium} {
                ${createSizing(SIZING.sweaterNumber.large)};
            }
        }
    }
`;
